import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './LogAcessos.css';

function LogAcessos() {
  const { user } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get('/api/logs-acesso/')
      .then(r => { setLogs(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (!user?.is_superuser) {
    return (
      <div className="log-container">
        <div className="log-denied">
          <span>🔒</span>
          <h2>Acesso Restrito</h2>
          <p>Apenas o administrador geral pode visualizar os logs de acesso.</p>
        </div>
      </div>
    );
  }

  const filtered = logs.filter(l =>
    l.username.toLowerCase().includes(search.toLowerCase()) ||
    (l.first_name + ' ' + l.last_name).toLowerCase().includes(search.toLowerCase()) ||
    l.data_hora.includes(search)
  );

  // Estatísticas
  const hoje = new Date().toLocaleDateString('pt-BR');
  const loginsHoje = logs.filter(l => l.data_hora.startsWith(hoje.split('/').reverse().join('/'))||
    l.data_hora.includes(hoje.split('/')[0]+'/'+hoje.split('/')[1])).length;
  const usuariosUnicos = new Set(logs.map(l => l.username)).size;

  return (
    <div className="log-container">
      <div className="log-header">
        <div className="log-header-identity">
          <span className="log-header-icon">≡</span>
          <div>
          <span className="log-header-eyebrow">CBACV 2026 · Segurança</span>
          <h1 className="log-titulo">Log de Acessos</h1>
          <p className="log-sub">Registro de todos os logins realizados no sistema</p>
          </div>
        </div>
      </div>

      {/* Cards de resumo */}
      <div className="log-stats">
        <div className="log-stat-card">
          <span className="log-stat-num">{logs.length}</span>
          <span className="log-stat-label">Total de Logins</span>
        </div>
        <div className="log-stat-card">
          <span className="log-stat-num">{usuariosUnicos}</span>
          <span className="log-stat-label">Usuários Únicos</span>
        </div>
        <div className="log-stat-card">
          <span className="log-stat-num">{loginsHoje}</span>
          <span className="log-stat-label">Logins Hoje</span>
        </div>
      </div>

      {/* Busca */}
      <div className="log-search">
        <span>🔍</span>
        <input
          placeholder="Buscar por usuário, nome ou data…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        {search && <button onClick={() => setSearch('')}>✕</button>}
      </div>

      {loading ? (
        <div className="log-loading">Carregando logs…</div>
      ) : filtered.length === 0 ? (
        <div className="log-vazio">Nenhum registro encontrado.</div>
      ) : (
        <div className="log-table-wrapper">
          <table className="log-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Usuário</th>
                <th>Nome Completo</th>
                <th>Data e Hora</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((l, idx) => (
                <tr key={l.id}>
                  <td className="log-idx">{idx + 1}</td>
                  <td><span className="log-username">@{l.username}</span></td>
                  <td>{(l.first_name || l.last_name) ? `${l.first_name} ${l.last_name}`.trim() : <span className="log-muted">—</span>}</td>
                  <td className="log-datetime">
                    <span className="log-date">{l.data_hora.substring(0,10)}</span>
                    <span className="log-time">{l.data_hora.substring(11,19)}</span>
                  </td>
                  <td className="log-ip">{l.ip || <span className="log-muted">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default LogAcessos;
